import React, { useState, useEffect } from 'react';
import { quantinoAvatarMap } from './quantinoAvatarMap';
import './Quantino.css';

const Quantino = ({ mood = 'neutral', message, isVisible = true, isBubbleVisible: initialIsBubbleVisible = true, inline = false }) => {
    const [displayedMessage, setDisplayedMessage] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const [isBubbleVisible, setIsBubbleVisible] = useState(initialIsBubbleVisible);

    useEffect(() => {
        setIsBubbleVisible(initialIsBubbleVisible);
    }, [initialIsBubbleVisible]);

    useEffect(() => {
        // If there's no message or the bubble shouldn't be visible, clear everything and exit.
        if (!message || !isBubbleVisible) {
            setDisplayedMessage('');
            setIsTyping(false);
            return;
        }

        setIsTyping(true);
        setDisplayedMessage(''); // Always start with a blank message.

        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < message.length) {
                // Build the displayed message using a substring.
                // This is more robust against React state update race conditions.
                setDisplayedMessage(message.substring(0, i + 1));
                i++;
            } else {
                // Once the message is fully typed, clear the interval and stop the typing indicator.
                clearInterval(typingInterval);
                setIsTyping(false);
            }
        }, 30); // Typing speed in milliseconds.

        // The cleanup function for the useEffect hook.
        // This will run when the component unmounts or when `message` or `isBubbleVisible` changes.
        return () => {
            clearInterval(typingInterval);
        };
    }, [message, isBubbleVisible]);

    const avatarSrc = quantinoAvatarMap[mood] || quantinoAvatarMap.default;

    if (!isVisible) {
        return null;
    }

    const isSpeaking = isBubbleVisible && message;
    const containerClassName = inline ? 'quantino-container-inline' : 'quantino-container';

    return (
        <div className={containerClassName}>
            <img 
                src={avatarSrc} 
                alt={`Quantino ${mood}`} 
                className={`quantino-avatar ${isSpeaking ? 'speaking' : ''}`} 
            />
            <div className={`quantino-speech-bubble ${isSpeaking ? 'visible' : ''}`}>
                {displayedMessage}
                {isTyping && <span className="typing-cursor"></span>}
            </div>
        </div>
    );
};

export default Quantino;
